import { render } from "./MedicinePage.vue?vue&type=template&id=308d6eec&scoped=true"
import script from "./MedicinePage.vue?vue&type=script&lang=js"
export * from "./MedicinePage.vue?vue&type=script&lang=js"

import "./MedicinePage.vue?vue&type=style&index=0&id=308d6eec&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308d6eec"]])

export default __exports__